import { useMemo } from 'react';
import {
  SECTORS,
  DEFAULT_SECTOR,
  parseSectorFromHostname,
  type SectorKey,
  type SectorConfig,
} from '../config/sectors';

const IS_DEMO = import.meta.env.VITE_DEMO_MODE === 'true';

function resolveSector(): SectorKey {
  if (typeof window === 'undefined') return DEFAULT_SECTOR;

  const urlParam = new URLSearchParams(window.location.search).get('sector');
  if (urlParam && urlParam in SECTORS) return urlParam as SectorKey;

  if (!IS_DEMO) return DEFAULT_SECTOR;

  const parsed = parseSectorFromHostname(window.location.hostname);
  return parsed ?? DEFAULT_SECTOR;
}

export function useActiveSector(): SectorConfig {
  return useMemo(() => SECTORS[resolveSector()], []);
}

export function getActiveSector(): SectorConfig {
  return SECTORS[resolveSector()];
}
